import { useEffect, useRef, useState } from 'react';
import { getPusher } from './pusherSingleton';

const usePusherPost = (postId, currentUserId, onNewComment) => {
    const [typingUsers, setTypingUsers] = useState([]);
    const timersRef   = useRef({});
    const onNewCommentRef = useRef(onNewComment);
    useEffect(() => { onNewCommentRef.current = onNewComment; }, [onNewComment]);

    useEffect(() => {
        if (!postId || !getPusher()) return;

        const pusher  = getPusher();
        const channel = pusher.subscribe(`post.${postId}`);

        channel.bind('typing', (data) => {
            if (data.user_id == currentUserId) return;
            setTypingUsers(prev => {
                if (prev.find(u => u.user_id == data.user_id)) return prev;
                return [...prev, data];
            });
            if (timersRef.current[data.user_id]) clearTimeout(timersRef.current[data.user_id]);
            timersRef.current[data.user_id] = setTimeout(() => {
                setTypingUsers(prev => prev.filter(u => u.user_id != data.user_id));
            }, 3000);
        });

        channel.bind('new-comment', (data) => {
            if (onNewCommentRef.current) onNewCommentRef.current(data.comment);
        });

        return () => {
            pusher.unsubscribe(`post.${postId}`);
            Object.values(timersRef.current).forEach(clearTimeout);
        };
    }, [postId, currentUserId]);

    return typingUsers;
};

export default usePusherPost;
